import ModuleIndexPage from "lx/moduleIndexPage";

export { ModuleIndexPage };

customElements.define(
  "lx-module-index-page",
  ModuleIndexPage.CustomElementConstructor
);
